export const BASE_URL = process.env.baseURL;

/*Package Module APIS */

export const GET_ALL_PACKAGES = 'api/package-master/';
export const GET_ALL_PACKAGE_TYPE = '/api/package-type-master/';
export const GET_ALL_HEAD_TYPE = '/api/package-master/get-io-heads';
export const GET_PACKAGE_CODE_LIST = '/api/package-master/package-codes';

export const GET_ALL_PRODUCTS = 'api/unit/get-product';

/*Region Module APIS */

export const REGION_PROJECT_LISTING = 'api/region/project-listing';
export const REGION_PROJECT_DATE = 'api/region/project-date';
export const REGION_PROJECT_SUMMARY = 'api/region/project-summary';
export const REGION_PROJECT_SUMMARY_VERSIONED = 'api/region/project-summary-v';
export const REGION_ALLOCATION_SUMMARY = 'api/region/allocation-summary';
export const REGION_GET_COMMERCIAL_UNIT = 'api/region/unit-commercial';
export const REGION_GET_TABLES_UPLOAD_STATUS = 'api/region/upload-status';
export const REGION_ADD_PACKAGE = 'api/region/add-packages-project-cost';
// export const REGION_MILESTONE_SUMMARY = 'api/region/milestone-summary';
export const REGION_MILESTONE_SUMMARY = 'api/region/peps-milestone-summary';
export const REGION_DOWNLOAD_EXCEL = {
        project_cost: 'api/region/download-project-cost-excel',
        other_apportioned_cost: 'api/region/download-apportioned-cost-excel',
        other_operational_income: 'api/region/download-operational-income-excel',
        billing: 'api/region/download-billing-excel',
        cash_inflow: 'api/region/download-cash-inflow-excel',
        cash_outflow: 'api/region/download-cash-outflow-excel',
        direct_order: '/api/direct-orders/download-direct-order-excel',
        direct_order_other_apportioned_cost: '/api/direct-orders/download-other-aportion',
        direct_order_input: '/api/direct-orders/download-direct-order-input-excel',
        iut: '/api/iut/download-iut-excel',
        iut_input: '/api/iut/download-iut-input-excel',
        iut_other_apportioned_cost: '/api/iut/download-other-aportion',
        anticipated_order_input: '/api/anticipated-orders/download-anticipated-order-input-excel',
        anticipated_order_other_apportioned_cost: '/api/anticipated-orders/download-other-aportion',
        operating_performance: '/api/operating-performance/download-operating-performance-excel',
        notes_to_operating: '/api/operating-performance/download-notes-to-operating-excel',
        personnel_payments: '/api/operating-performance/download-personnel-payments-excel',
        miscellaneous_expenses: '/api/operating-performance/download-miscellaneous-expenses-excel',
        other_projects_project_cost_direct_material: '/api/other-projects/download-direct-material',
        other_projects_project_cost_conversion_cost: '/api/other-projects/download-conversion',
        other_projects_other_apportioned_cost: '/api/other-projects/download-other-aportion',
        other_projects_other_operational_income: '/api/other-projects/download-operational',
        other_projects_gross_billing: '/api/other-projects/download-gross-billing',
        other_projects_net_billing: '/api/other-projects/download-net-billing',
        other_projects_cash_inflow: '/api/other-projects/download-cash-inflow',
        other_projects_cash_outflow: '/api/other-projects/download-cash-outflow',
        other_projects_project_level: '/api/other-projects/download-other-projects-excel',
};
export const UNIT_DOWNLOAD_EXCEL = {
        project_cost: 'api/unit/download-project-cost-excel',
        other_apportioned_cost: 'api/unit/download-apportioned-cost-excel',
        other_operational_income: 'api/unit/download-operational-income-excel',
        billing: 'api/unit/download-billing-excel',
        cash_inflow: 'api/unit/download-cash-inflow-excel',
        cash_outflow: 'api/unit/download-cash-outflow-excel',
        direct_order_input: '/api/direct-orders/download-direct-order-input-excel',
        direct_order: '/api/direct-orders/download-direct-order-excel',
        direct_order_other_apportioned_cost: '/api/direct-orders/download-other-aportion',
        iut: '/api/iut/download-iut-excel',
        iut_input: '/api/iut/download-iut-input-excel',
        iut_other_apportioned_cost: '/api/iut/download-other-aportion',
        anticipated_order_input: '/api/anticipated-orders/download-anticipated-order-input-excel',
        anticipated_order_other_apportioned_cost: '/api/anticipated-orders/download-other-aportion',
        operating_performance: '/api/operating-performance/download-operating-performance-excel',
        notes_to_operating: '/api/operating-performance/download-notes-to-operating-excel',
        personnel_payments: '/api/operating-performance/download-personnel-payments-excel',
        miscellaneous_expenses: '/api/operating-performance/download-miscellaneous-expenses-excel',
        other_projects_project_cost_direct_material: '/api/other-projects/download-direct-material',
        other_projects_project_cost_conversion_cost: '/api/other-projects/download-conversion',
        other_projects_other_apportioned_cost: '/api/other-projects/download-other-aportion',
        other_projects_other_operational_income: '/api/other-projects/download-operational',
        other_projects_gross_billing: '/api/other-projects/download-gross-billing',
        other_projects_net_billing: '/api/other-projects/download-net-billing',
        other_projects_cash_inflow: '/api/other-projects/download-cash-inflow',
        other_projects_cash_outflow: '/api/other-projects/download-cash-outflow',
        other_projects_project_level: '/api/other-projects/download-other-projects-excel',
};
export const REGION_UPLOAD_EXCEL = {
        project_cost: 'api/region/upload-project-cost',
        other_apportioned_cost: 'api/region/upload-aportioned-cost',
        other_operational_income: 'api/region/upload-operational-income',
        billing: 'api/region/upload-billing',
        cash_inflow: 'api/region/upload-cash-inflow',
        cash_outflow: 'api/region/upload-cash-outflow',
        direct_order_input: '/api/direct-orders/upload-direct-order-input-excel',
        direct_order_other_apportioned_cost: '/api/direct-orders/upload-other-aportion',
        direct_order: '/api/direct-orders/upload-direct-order-excel',
        iut: '/api/iut/upload-iut-excel',
        iut_input: '/api/iut/upload-iut-input-excel',
        iut_other_apportioned_cost: '/api/iut/upload-other-aportion',
        anticipated_order_input: '/api/anticipated-orders/upload-anticipated-order-input-excel',
        anticipated_order_other_apportioned_cost: '/api/anticipated-orders/upload-other-aportion',
        operating_performance: '/api/operating-performance/upload-operating-performance',
        notes_to_operating: '/api/operating-performance/upload-notes-to-operating',
        personnel_payments: '/api/operating-performance/upload-personnel-payments',
        miscellaneous_expenses: '/api/operating-performance/upload-miscellaneous-expenses',
        other_projects_project_cost_direct_material: '/api/other-projects/upload-direct-material',
        other_projects_project_cost_conversion_cost: '/api/other-projects/upload-conversion',
        other_projects_other_apportioned_cost: '/api/other-projects/upload-other-aportion',
        other_projects_other_operational_income: '/api/other-projects/upload-operational',
        other_projects_gross_billing: '/api/other-projects/upload-gross-billing',
        other_projects_net_billing: '/api/other-projects/upload-net-billing',
        other_projects_cash_inflow: '/api/other-projects/upload-cash-inflow',
        other_projects_cash_outflow: '/api/other-projects/upload-cash-outflow',
        other_projects_project_level: '/api/other-projects/upload-other-projects-excel',
};
export const UNIT_UPLOAD_EXCEL = {
        project_cost: 'api/unit/upload-project-cost',
        other_apportioned_cost: 'api/unit/upload-aportioned-cost',
        other_operational_income: 'api/unit/upload-operational-income',
        billing: 'api/unit/upload-billing',
        cash_inflow: 'api/unit/upload-cash-inflow',
        cash_outflow: 'api/unit/upload-cash-outflow',
        direct_order_input: '/api/direct-orders/upload-direct-order-input-excel',
        direct_order_other_apportioned_cost: '/api/direct-orders/upload-other-aportion',
        direct_order: '/api/direct-orders/upload-direct-order-excel',
        iut: '/api/iut/upload-iut-excel',
        iut_input: '/api/iut/upload-iut-input-excel',
        iut_other_apportioned_cost: '/api/iut/upload-other-aportion',
        anticipated_order_input: '/api/anticipated-orders/upload-anticipated-order-input-excel',
        anticipated_order_other_apportioned_cost: '/api/anticipated-orders/upload-other-aportion',
        operating_performance: '/api/operating-performance/upload-operating-performance',
        notes_to_operating: '/api/operating-performance/upload-notes-to-operating',
        personnel_payments: '/api/operating-performance/upload-personnel-payments',
        miscellaneous_expenses: '/api/operating-performance/upload-miscellaneous-expenses',
        other_projects_project_cost_direct_material: '/api/other-projects/upload-direct-material',
        other_projects_project_cost_conversion_cost: '/api/other-projects/upload-conversion',
        other_projects_other_apportioned_cost: '/api/other-projects/upload-other-aportion',
        other_projects_other_operational_income: '/api/other-projects/upload-operational',
        other_projects_gross_billing: '/api/other-projects/upload-gross-billing',
        other_projects_net_billing: '/api/other-projects/upload-net-billing',
        other_projects_cash_inflow: '/api/other-projects/upload-cash-inflow',
        other_projects_cash_outflow: '/api/other-projects/upload-cash-outflow',
        other_projects_project_level: '/api/other-projects/upload-other-projects-excel',
};
export const PMG_UPLOAD_EXCEL = {
        project: 'api/admin/pmg-projects/bulk',
};
export const PMG_DOWNLOAD_EXCEL = {
        project: 'api/admin/download-pmg-projects-excel',
};
export const PMG_MILESTONE_DOWNLOAD_EXCEL = {
        project_milestone: 'api/admin/download-pmg-milestones-excel',
};
export const PMG_MILESTONE_UPLOAD_EXCEL = {
        project_milestone: '/api/admin/pmg-milestones/bulk',
};
export const PMG_MILESTONE_MAPPING_UPLOAD_EXCEL = {
        project_milestone_mapping: 'api/admin/pmg-set-milestone-mappings/bulk',
};
export const PMG_MILESTONE_MAPPING_DOWNLOAD_EXCEL = {
        project_milestone_mapping: 'api/admin/download-pmg-set-milestone-mappings-excel',
};

export const REGION_ADD_INTIAL_TECC = 'api/region/initial-estimate-master';
export const REGION_IO_HEADS = 'api/region/project-io-heads';
export const REGION_GET_INITIAL_TECC = 'api/region/get-initial-estimate';
export const REGION_GET_PROJECT_COST = 'api/region/get-project-cost';
export const REGION_GET_PROJECT_COST_VERSIONED = 'api/region/get-project-cost-v';
export const UNIT_GET_PROJECT_COST = 'api/unit/get-project-cost';
export const UNIT_GET_PROJECT_COST_VERSIONED = 'api/unit/get-project-cost-v';

export const REGION_GET_BILLING_COST = 'api/region/get-billing';
export const REGION_GET_BILLING_COST_VERSIONED = 'api/region/get-billing-v';
export const REGION_GET_APPORTIONED_COST = 'api/region/get-apportion-cost';
export const REGION_GET_APPORTIONED_COST_VERSIONED = 'api/region/get-apportion-cost-v';
export const UNIT_GET_APPORTIONED_COST = 'api/unit/get-apportion-cost';
export const UNIT_GET_APPORTIONED_COST_VERSIONED = 'api/unit/get-apportion-cost-v';
export const REGION_GET_BILLING_ADD_PACKAGE = 'api/region/add-packages-billing';
export const REGION_GET_CASH_INFLOW = '/api/region/get-cash-inflow';
export const REGION_GET_CASH_INFLOW_VERSIONED = '/api/region/get-cash-inflow-v';
export const REGION_GET_CASH_OUTFLOW = '/api/region/get-cash-outflow';
export const REGION_GET_CASH_OUTFLOW_VERSIONED = '/api/region/get-cash-outflow-v';
export const REGION_GET_OPERATIONAL_INCOME = 'api/region/get-operational-income';
export const REGION_GET_OPERATIONAL_INCOME_VERSIONED = 'api/region/get-operational-income-v';
export const UNIT_GET_OPERATIONAL_INCOME = 'api/unit/get-operational-income';
export const UNIT_GET_OPERATIONAL_INCOME_VERSIONED = 'api/unit/get-operational-income-v';
export const REGION_GET_PROJECT_REVENUE = 'api/region/project-revenue';
export const REGION_GET_PROJECT_REVENUE_VERSIONED = 'api/region/project-revenue-v';
export const REGION_GET_PROJECT_PROFIT_LOSS = 'api/region/get-profit-and-loss';
export const REGION_GET_PROJECT_PROFIT_LOSS_VERSIONED = 'api/region/get-profit-and-loss-v';
export const REGION_GET_CUSTOM_CARDS = '/api/region/custom-cards';
export const REGION_GET_CUSTOM_CARDS_VERSIONED = '/api/region/custom-cards-versioned';
export const REGION_OVERALL_GET_CUSTOM_CARDS = '/api/region/all-custom-cards';
export const REGION_DELETE_PACKAGES = '/api/region/delete-package';
export const SAVE_AS_DRAFT = '/api/region/save-as-draft';
export const INITIATE_FINAL_SUBMISSION_STATUS = '/api/region/check-final-submission';
export const PROJECT_STATUS = '/api/region/get-project-status';
export const EXTENDED_PROJECT_LISTING = '/api/region/get-direct-anticipated-other';

{
        /*UNIT APIS */
}
export const UNIT_PRODUCT_LISTING = 'api/unit/get-unit-wise-product';
export const UNIT_PRODUCT_TYPE = 'api/unit/unit-product-type';
export const UNIT_ADD_PRODUCT = 'api/unit/add-product-project-cost';
export const UNIT_GET_CASH_INFLOW = 'api/unit/get-cash-inflow';
export const UNIT_GET_CASH_INFLOW_VERSIONED = 'api/unit/get-cash-inflow-v';
export const UNIT_GET_CASH_OUTFLOW = 'api/unit/get-cash-outflow';
export const UNIT_GET_CASH_OUTFLOW_VERSIONED = 'api/unit/get-cash-outflow-v';
export const UNIT_GET_BILLING = '/api/unit/get-billing';
export const UNIT_GET_BILLING_VERSIONED = '/api/unit/get-billing-v';
export const UNIT_ADD_PRODUCT_BILLING = 'api/unit/add-product-billing';
export const UNIT_GET_CUSTOM_CARDS = '/api/unit/custom-cards';
export const UNIT_GET_CUSTOM_CARDS_VERSIONED = '/api/unit/custom-cards-versioned';
export const UNIT_PROJECT_SUMMARY = 'api/unit/project-summary';
export const UNIT_PROJECT_SUMMARY_VERSIONED = 'api/unit/project-summary-v';
export const UNIT_GET_PROJECT_PROFIT_LOSS = 'api/unit/get-profit-and-loss';
export const UNIT_GET_PROJECT_PROFIT_LOSS_VERSIONED = 'api/unit/get-profit-and-loss-v';
export const UNIT_GET_PROJECT_REVENUE = 'api/unit/project-revenue';
export const UNIT_GET_PROJECT_REVENUE_VERSIONED = 'api/unit/project-revenue-v';
export const UNIT_DELETE_PRODUCTS = '/api/unit/delete-product';
export const UNIT_PROJECT_LISTING = 'api/unit/project-listing';
export const UNIT_GET_TABLES_UPLOAD_STATUS = 'api/unit/upload-status';
export const UNIT_OVERALL_GET_CUSTOM_CARDS = '/api/unit/all-custom-cards';
export const UNIT_GET_DIRECT_MATERIAL_GRAPH = 'api/operating-performance/get-notes-to-operating/direct-material-graph';
export const UNIT_GET_PERSONNEL_PAYMENT_GRAPH = 'api/operating-performance/get-personnel-payments/personnel-payment-graph';
export const UNIT_GET_MISC_EXPENSES_GRAPH = 'api/operating-performance/get-miscellaneous-expenses/miscellaneous-expenses-graph';
export const UNIT_GET_INDIRECT_MATERIAL_GRAPH = 'api/operating-performance/get-operating-performance/indirect-material-graph';
export const UNIT_GET_POWER_GRAPH = 'api/operating-performance/get-operating-performance/power-supplies-graph';
export const UNIT_GET_EBITDA_GRAPH = 'api/operating-performance/get-operating-performance/ebitda-graph';
export const UNIT_GET_PROFIT_LOSS_GRAPH = '/api/operating-performance/get-operating-performance/profit-loss-graph';
export const UNIT_GET_REVENUE_GRAPH = 'api/operating-performance/get-notes-to-operating/revenue-graph';
export const UNIT_GET_NON_INDAS_PROJECTS = "/api/unit/non-indas-projects";
export const UNIT_POST_NON_INDAS_PROJECT = "/api/unit/non-indas-project";
{
        /*DIRECT ORDERS APIS */
}
export const GET_DIRECT_ORDER = '/api/direct-orders/get-direct-order';
export const GET_DIRECT_ORDER_VERSIONED = '/api/direct-orders/get-direct-order-v';
export const GET_DIRECT_ORDER_SUMMARY = '/api/direct-orders/get-summary';
export const GET_DIRECT_ORDER_SUMMARY_VERSIONED = '/api/direct-orders/get-summary-v';
export const GET_DIRECT_ORDER_INPUT = '/api/direct-orders/get-direct-order-input';
export const GET_DIRECT_ORDER_INPUT_VERSIONED = '/api/direct-orders/get-direct-order-input-v';
export const GET_DIRECT_ORDER_DATES = '/api/direct-orders/get-date';
export const GET_DIRECT_ORDERS_UPLOAD_STATUS = '/api/direct-orders/upload-status';
export const DELETE_DIRECT_ORDER = '/api/direct-orders/delete-direct-order';

{
        /*IUT APIS */
}
export const GET_IUT = '/api/iut/get-iut';
export const GET_IUT_SUMMARY = '/api/iut/get-summary';
export const GET_IUT_INPUT = '/api/iut/get-iut-input';
export const GET_IUT_DATES = '/api/iut/get-date';
export const GET_IUT_UPLOAD_STATUS = '/api/iut/upload-status';
export const DELETE_IUT = '/api/iut/delete-iut';

{
        /*ANTICIPATED ORDERS APIS */
}
export const GET_BUSINESS_SECTOR = '/api/anticipated-orders/get-business-sector-listing';
export const ADD_ANTICIPATED_ORDER = '/api/anticipated-orders/add-anticipated-order';
export const UPDATE_ANTICIPATED_ORDER = '/api/anticipated-orders/update-anticipate-order/';
export const GET_ANTICIPATED_ORDER = '/api/anticipated-orders/get-anticipated-order';
export const GET_ANTICIPATED_ORDER_SUMMARY = '/api/anticipated-orders/get-summary';
export const GET_ANTICIPATED_ORDER_SUMMARY_VERSIONED = '/api/anticipated-orders/get-summary-v';
export const GET_ANTICIPATED_ORDER_INPUT = '/api/anticipated-orders/get-anticipated-order-input';
export const GET_ANTICIPATED_ORDER_INPUT_VERSIONED = '/api/anticipated-orders/get-anticipated-order-input-v';
export const GET_ANTICIPATED_ORDERS_UPLOAD_STATUS = '/api/anticipated-orders/upload-status';
export const DELETE_ANTICIPATED_ORDER = '/api/anticipated-orders/delete-anticipate-order';
export const GET_CUSTOM_CARD = {
        anticipatedOrders: '/api/anticipated-orders/custom-card',
        directOrders: '/api/direct-orders/custom-card',
        otherProjects: '/api/other-projects/custom-card',
        iut: '/api/iut/custom-card',
};
export const GET_CUSTOM_CARD_VERSIONED = {
        anticipatedOrders: '/api/anticipated-orders/custom-card-versioned',
        directOrders: '/api/direct-orders/custom-card-versioned',
        otherProjects: '/api/other-projects/custom-card-versioned',
};

// Operating Performance //
export const GET_OPERATING_PERFORMANCE = '/api/operating-performance/get-operating-performance';
export const GET_NOTES_TO_OPERATING = '/api/operating-performance/get-notes-to-operating';
export const GET_PERSONNEL_PAYMENTS = '/api/operating-performance/get-personnel-payments';
export const CALCULATE_OPERATING_PERFORMANCE = '/api/operating-performance/sync-operating-performance';
export const GET_MISCELLANEOUS_EXPENSES = '/api/operating-performance/get-miscellaneous-expenses';
export const GET_OPERATING_PERFORMANCE_UPLOAD_STATUS = '/api/operating-performance/upload-status';

// Other Projects
export const GET_OTHER_PROJECTS = '/api/other-projects/get-other-projects';

export const GET_OTHER_PROJECTS_TABLES_DATA = {
        other_projects_project_cost_direct_material: '/api/other-projects/get-direct-material',
        other_projects_project_cost_direct_material_versioned: '/api/other-projects/get-direct-material-v',
        other_projects_project_cost_conversion_cost: '/api/other-projects/get-conversion',
        other_projects_project_cost_conversion_cost_versioned: '/api/other-projects/get-conversion-v',
        other_projects_other_apportioned_cost: '/api/other-projects/get-other-aportion',
        other_projects_other_apportioned_cost_versioned: '/api/other-projects/get-other-aportion-v',
        other_projects_other_operational_income: '/api/other-projects/get-operational',
        other_projects_other_operational_income_versioned: '/api/other-projects/get-operational-v',
        other_projects_gross_billing: '/api/other-projects/get-gross-billing',
        other_projects_gross_billing_versioned: '/api/other-projects/get-gross-billing-v',
        other_projects_net_billing: '/api/other-projects/get-net-billing',
        other_projects_net_billing_versioned: '/api/other-projects/get-net-billing-v',
        other_projects_cash_inflow: '/api/other-projects/get-cash-inflow',
        other_projects_cash_inflow_versioned: '/api/other-projects/get-cash-inflow-v',
        other_projects_cash_outflow: '/api/other-projects/get-cash-outflow',
        other_projects_cash_outflow_versioned: '/api/other-projects/get-cash-outflow-v',
        other_projects_project_profit_loss_versioned: '/api/other-projects/profit-loss-v',
};
export const GET_OTHER_PROJECTS_DATE = "/api/other-projects/get-date";
export const SET_OTHER_PROJECTS_DATE = "/api/other-projects/set-date";
export const GET_OTHER_PROJECT_REVENUE = '/api/other-projects/get-revenue';
export const GET_OTHER_PROJECT_REVENUE_VERSIONED = '/api/other-projects/get-revenue-v';
export const GET_OTHER_PROJECT_PROFIT_LOSS = '/api/other-projects/profit-loss';
export const GET_OTHER_PROJECT_PROFIT_LOSS_VERSIONED = '/api/other-projects/profit-loss-v';
export const GET_OTHER_PROJECTS_UPLOAD_STATUS = '/api/other-projects/upload-status';
export const GET_OTHER_PROJECT_SUMMARY = '/api/other-projects/get-summary';
export const GET_OTHER_PROJECT_SUMMARY_VERSIONED = '/api/other-projects/get-summary-v';
export const GET_CUSTOM_CARD_OTHER_PROJECTS = '/api/other-projects/custom-card';
export const GET_CUSTOM_CARD_OTHER_PROJECTS_VERSIONED = '/api/other-projects/custom-card-versioned';
export const DELETE_OTHER_PROJECTS = '/api/other-projects/delete-other-project';
export const CALCULATE_OTHER_PROJECTS = '/api/other-projects/sync-other-project';

// --------------- Guideline Apis ------------
export const UPLOAD_GUIDELINE_FILE = '/api/users/upload';
export const GET_ALL_GUIDELINES = '/api/users/getAllPdfs';
export const GET_ALL_GUIDELINES_ADMIN = '/api/users/getAllPdfsAdmin';
export const DELETE_GUIDELINE = '/api/users/delete';

//-------------Admin API's------------------
// b. Projects
export const ADMIN_GET_ALL_PROJECTS = '/api/admin/all-project';
export const ADMIN_UPDATE_PROJECT_STATUS = '/api/admin/update-status';
export const ADMIN_UPDATE_PROJECT_MW = '/api/admin/update-project-mw';
export const ADMIN_GET_ACTIVE_PROJECTS = '/api/admin/active-project';
export const ADMIN_GET_PROJECT_SUBMISSION_STATUS = '/api/admin/project-submission-status-unit-wise';
export const ADMIN_GET_MONITORING_PROJECT_FILLED_STATUS = '/api/admin/unit-project-filled-status';
export const ADMIN_GET_OTHER_PROJECT_FILLED_STATUS = '/api/admin/other-project-filled-status';
export const ADMIN_GET_PROJECT_CUSTOM_CARDS = '/api/admin/project-custom-cards';
export const ADMIN_GET_PROJECT_REVENUE = '/api/admin/project-revenue';
export const ADMIN_GET_PROJECT_UNIT_WISE = 'api/admin/unit-wise-details';
export const ADMIN_GET_PROJECT_COMPLETION_GRAPH = '/api/admin/project-completion-graph';
export const ADMIN_GET_PROJECT_UNIT_WISE_GRAPH = '/api/admin/unit-wise-contribution-graph';
export const ADMIN_GET_PROJECT_YEAR_WISE_GRAPH = '/api/admin/project-year-wise-graph';
export const ADMIN_GET_PROJECT_WISE_SUMMARY = '/api/admin/project-wise-summary';
export const ADMIN_DOWNLOAD_UNIT_REGION_REPORT = '/api/admin/region-unit-listing';
export const ADMIN_REV_NO_LOGS ="/api/admin/rev-no/logs";
export const ADMIN_REV_NO_DOWNLOAD_TEMPLATE ="/api/admin/rev-no/download-template";
export const ADMIN_REV_NO_UPLOAD ="/api/admin/rev-no/upload";
export const CUSTOMER_GROUP_REPORT = '/api/admin/generate-report';
export const ADMIN_IO_DELETION_DOWNLOAD_MAPPING ="/api/admin/io-deletion/download-mapping";
export const ADMIN_IO_DELETION_UPLOAD ="/api/admin/io-deletion/upload";
export const ADMIN_IO_DELETION_LOGS ="/api/admin/io-deletion/logs";
export const ADMIN_IO_DELETION_LIST ="/api/admin/io-deletion/list";
export const ADMIN_IO_DELETION_IGNORE ="/api/admin/io-deletion/ignore";
export const ADMIN_IO_DELETION_DELETE ="/api/admin/io-deletion/delete";
export const ADMIN_UNIT_WISE_COST ="/api/admin/unit-wise-cost";

//Master Uploads endpoints
export const CUSTOMER_GROUP_MASTER = "/api/admin/customer-group-master";
export const CUSTOMER_GROUP_MASTER_DOWNLOAD_TEMPLATE = "/api/admin/customer-group-master/download-template";
export const CUSTOMER_MASTER = "/api/admin/customer-master";
export const CUSTOMER_MASTER_DOWNLOAD_TEMPLATE = "/api/admin/customer-master/download-template";
export const CPC_MASTER = "/api/admin/cpc-master";
export const CPC_MASTER_DOWNLOAD_TEMPLATE = "/api/admin/cpc-master/download-template";

//Dashboard endpoints
export const ADMIN_DASHBOARD_CUSTOM_CARD = '/api/admin/project-custom-cards';
export const ADMIN_TOP_10_PROJECT_LISTING = '/api/admin/top-ten-project-listing';
export const ADMIN_TOP_10_PROJECTS = '/api/admin/top-ten-projects-graph';
export const ADMIN_PRIORITY_UNITS = '/api/admin/bhel-top-projects';
export const ADMIN_DASHBOARD_BUSINESS_SECTORWISE_REVENUE = '/api/admin/bs-wise-revenue-graph';
export const ADMIN_REVENUE_GRAPH = '/api/operating-performance/get-notes-to-operating/revenue-graph';
export const ADMIN_TOP_10_PROJECT_WITHIN_FY = '/api/admin/top-ten-projects-graph-within-fy';
export const ADMIN_PROJECT_REPORT_CUSTOMER_GROUP_WISE_LISTING = '/api/admin/projects-with-customer-group';
export const ADMIN_CUSTOMER_GROUP_LIST = '/api/admin/customer-group';

//Parallel flow of Anticipated/Other/Direct
export const ADMIN_GET_UNIT_REGION_DIRECT_ORDERS = '/api/admin/direct-orders';
export const ADMIN_GET_UNIT_REGION_ANTICIPATED_ORDERS = '/api/admin/anticipated-orders';
export const ADMIN_GET_UNIT_REGION_OTHER_PROJECTS = '/api/admin/other-projects';
export const ADMIN_GET_UNIT_REGION_OTHER_PROJECTS_DETAILS = '/api/admin/other-projects-details';

//a. Unit/Region Api's
export const ADMIN_GET_UNIT_REGION_PROJECTS = '/api/admin/region-unit-listing';
export const ADMIN_GET_UNIT_REGION_ALL_UNITS = '/api/admin/all-units';
export const ADMIN_GET_UNIT_REGION_GRAPH_PROFITABILITY_CASH_PERFORMANCE = '/api/admin/year-wise-graph';
export const ADMIN_GET_GRAPH_TOP_TEN_PROJECTS = '/api/admin/top-ten-projects-graph';
export const ADMIN_PROJECT_DETAILS_PROJECT_WISE = '/api/admin/project-details-project-wise';

//CONSOLIDATED REPORTS API

export const ADMIN_YEARLY_GRAPH = "/api/admin/yearly-graph"
export const ADMIN_QUATERLY_GRAPH = "/api/admin/quarterly-graph"
export const ADMIN_UNIT_WISE_REPORT = "/api/admin/unit-wise"
export const ADMIN_IUT_UNIT_WISE_REPORT = "/api/admin/iut-unit-wise"
export const ADMIN_PROJECT_WISE_REPORT = "/api/admin/project-wise"
// export const ADMIN_BUDGET_REPORT="/api/admin/budget-report"
export const ADMIN_BUDGET_REPORT = "/api/admin/budget-report-optimized"
// export const ADMIN_ACUTAL_BUDGET_REPORT="/api/admin/get-projected-budget-template"
export const ADMIN_ACUTAL_BUDGET_REPORT = "/api/admin/get-projected-budget-template-optimized"
export const ADMIN_OPERATING_PERFORMANCE_REPORT = "/api/operating-performance/get-operating-performance-admin"
export const ADMIN_NOTES_TO_OPERATING_REPORT = "/api/operating-performance/get-notes-to-operating-admin"
export const ADMIN_OPERATING_PERFORMANCE_REPORT_MISC_EXPENSES = "/api/operating-performance/get-miscellaneous-expenses-admin"
export const ADMIN_OPERATING_PERFORMANCE_REPORT_PERSONNEL_PAYMENTS = "/api/operating-performance/get-personnel-payments-admin"
export const ADMIN_OPERATING_PERFORMANCE_REPORT_BY_UNIT = "/api/operating-performance/get-operating-performance-by-unit"
export const ADMIN_NOTES_TO_OPERATING_REPORT_BY_UNIT = "/api/operating-performance/get-notes-to-operating-by-unit"
export const ADMIN_OPERATING_PERFORMANCE_REPORT_MISC_EXPENSES_BY_UNIT = "/api/operating-performance/get-miscellaneous-expenses-by-unit"
export const ADMIN_OPERATING_PERFORMANCE_REPORT_PERSONNEL_PAYMENTS_BY_UNIT = "/api/operating-performance/get-personnel-payments-by-unit"
// export const ADMIN_EXECUTION_REPORT="/api/admin/execution-plan"
export const ADMIN_EXECUTION_REPORT = "/api/admin/execution-plan-optimized"
export const ADMIN_PROJECTS_BALANCE_REPORT = "/api/admin/all-projects-balance-revenue"
export const ADMIN_OTHER_PROJECT_EXECUTION_PLAN = "/api/admin/other-project-execution-plan";
export const ADMIN_ALL_PROJECT_EXECUTION_PLAN = "/api/admin/all-project-execution-plan";
// export const ADMIN_BUSINESS_SECTOR_WISE_EXECUTION_PLAN = "/api/admin/business-sector-wise-execution-plan";
export const ADMIN_BUSINESS_SECTOR_WISE_EXECUTION_PLAN = "/api/admin/business-sector-wise-execution-plan-optimized";
export const ADMIN_BUSINESS_SECTOR_OTHER_PROJECTS = "/api/admin/business-sector-other-projects";
export const ADMIN_SET_UPLOAD_LOCK ="/api/admin/set-upload-lock";
export const ADMIN_EXPORT_EXCEL = {
        admin_unit_region_listing: ADMIN_GET_UNIT_REGION_PROJECTS,
        admin_top_10_projects: ADMIN_TOP_10_PROJECTS,
        admin_top_10_project_listing_business_sector_wise: ADMIN_TOP_10_PROJECT_LISTING,
        admin_project_completion_within_fy: ADMIN_TOP_10_PROJECT_WITHIN_FY,
        admin_all_projects_list: ADMIN_GET_ALL_PROJECTS,
        admin_active_projects_list: ADMIN_GET_ACTIVE_PROJECTS,
        admin_unit_wise_details_list: ADMIN_GET_PROJECT_UNIT_WISE,
        admin_operating_performance: GET_OPERATING_PERFORMANCE,
        admin_notes_to_operating: GET_NOTES_TO_OPERATING,
        admin_personnel_payments: GET_PERSONNEL_PAYMENTS,
        admin_miscellaneous_expenses: GET_MISCELLANEOUS_EXPENSES,
        admin_direct_orders_list: ADMIN_GET_UNIT_REGION_DIRECT_ORDERS,
        admin_anticipated_orders_list: ADMIN_GET_UNIT_REGION_ANTICIPATED_ORDERS,
        project_report_customer_group_wise: ADMIN_PROJECT_REPORT_CUSTOMER_GROUP_WISE_LISTING,
        admin_other_projects_list: ADMIN_GET_UNIT_REGION_OTHER_PROJECTS,
        admin_other_projects_details_list: ADMIN_GET_UNIT_REGION_OTHER_PROJECTS_DETAILS,
        customer_group_report: CUSTOMER_GROUP_REPORT,

};
export const ADMIN_PROJECT_WISE_COST ="/api/admin/project-wise-cost";
export const ADMIN_PROJECT_WISE_COST_PER_MW ="/api/admin/project-wise-cost-per-mw";
export const ADMIN_MONITORING_PROJECT_LIST ="/api/admin/monitoring-project-list";

// PMG API
export const PMG_GET_PROJECTS_LISTING = '/api/admin/pmg-project-list';
export const PMG_GET_MS_CODE = '/api/admin/mscode-list';
export const PMG_ADD_PROJECT = '/api/admin/add-pmg';
export const PMG_EDIT_PROJECT = '/api/admin/update-pmg';

//Internal Order Master
export const GET_INTERNAL_ORDER_MASTER_LISTING = '/api/admin/internal-orders';
export const ADD_INTERNAL_ORDER_MASTER = '/api/admin/internal-orders';
export const EDIT_INTERNAL_ORDER_MASTER = '/api/admin/internal-orders/update';

export const INTERNAL_ORDER_MASTER_BULK_UPLOAD = '/api/admin/internal-orders/bulk';
export const INTERNAL_ORDER_MASTER_BULK_DOWNLOAD = '/api/admin/download-internal-orders-excel';

//IO INDAS DATA MAPPING
export const GET_IO_INDAS_DATA_MAPPING_LISTING = '/api/admin/io-indas-mapping';
export const ADD_IO_INDAS_DATA_MAPPING = '/api/admin/io-indas-mapping';
export const EDIT_IO_INDAS_DATA_MAPPING = '/api/admin/io-indas-mapping/update';

export const IO_INDAS_DATA_MAPPING_BULK_UPLOAD = '/api/admin/io-indas-mapping/bulk';
export const IO_INDAS_DATA_MAPPING_BULK_DOWNLOAD = '/api/admin/download-io-indas-mapping-excel';

//IO UNIT MAPPING
export const GET_IO_UNIT_MAPPING_LISTING = '/api/admin/io-unit-mapping';
export const ADD_IO_UNIT_MAPPING = '/api/admin/io-unit-mapping';
export const DELETE_IO_UNIT_MAPPING = '/api/admin/io-indas-mapping/update';

export const IO_UNIT_MAPPING_BULK_UPLOAD = '/api/admin/io-unit-mapping/bulk';
export const IO_UNIT_MAPPING_BULK_DOWNLOAD = '/api/admin/download-io-unit-mapping-excel';

//IO ALLOCATION
export const GET_IO_ALLOCATIOn_LISTING = '/api/admin/io-allocation';
export const ADD_IO_ALLOCATION = '/api/admin/io-allocation';
export const EDIT_IO_ALLOCATION = '/api/admin/io-allocation/update';

export const IO_ALLOCATION_BULK_UPLOAD = '/api/admin/io-allocation/bulk';
export const IO_ALLOCATION_BULK_DOWNLOAD = '/api/admin/download-io-allocation-excel';

//caching
export const CLEAR_ADMIN_CACHE = '/api/admin/clear-admin-get-cache';